// import * as QR from "./qr";
import * as NQR from "./nqr";
import * as CARD from "./card";
import * as PAGA from "./paga";
import * as USSD from "./ussd";
import * as MPESA from "./mpesa";
// import * as BARTER from "./barter";
import * as PAYPAL from "./paypal";
// import * as WECHAT from "./wechat";
import * as ACCOUNT from "./account";
import * as FAWRYPAY from "./fawrypay";
import * as APPLE_PAY from "./applepay";
import * as GOOGLE_PAY from "./googlepay";
import * as FLASH_VOUCHER from "./1voucher";
// import * as PAYATTITUDE from "./payattitude";
import * as BANK_TRANSFER from "./banktransfer";
import * as CRYPTOCURRENCY from "./cryptocurrency";
// import * as INTERNET_BANKING from "./internetbanking";
import * as MOBILE_MONEY_GHANA from "./mobilemoneyghana";
import * as MOBILE_MONEY_FRANCO from "./mobilemoneyfranco";
import * as MOBILE_MONEY_MALAWI from "./mobilemoneymalawi";
import * as MOBILE_MONEY_RWANDA from "./mobilemoneyrwanda";
import * as MOBILE_MONEY_UGANDA from "./mobilemoneyuganda";
import * as MOBILE_MONEY_ZAMBIA from "./mobilemoneyzambia";
import * as MOBILE_MONEY_TANZANIA from "./mobilemoneytanzania";
import * as ENAIRA from "./enaira";
import * as OPAY from "./opay";
import * as CAPITEC from "./capitec";

import { withChargeFunctions } from "../helpers/charge";
import { callback, isPlainObject, objectWithAccessors, withProperties } from "../../../utils";

function __setupContext__(data, store) {
  const { dispatch, getState } = store;
  const { CHARGE_MODE: mode, getChargeData, getViewsContext } = this;

  const $viewsContext = getViewsContext(data, store) || Object.create(null);
  const $chargeContext = withProperties(Object.create(null), { mode });

  Object.freeze(objectWithAccessors.call($chargeContext, {
    data: callback(getChargeData).bind($viewsContext)
  }));

  withChargeFunctions.call($chargeContext, $viewsContext);

  withProperties($viewsContext, { dispatch });

  return objectWithAccessors.call($viewsContext, {
    DATA() { return data },
    STATE() { return getState() }
  });
}

function __initialize__(data, store) {
  if (isPlainObject(this)) {
    const {
      VIEWS,
      METHOD: method,
      METHOD_NAME: name,
      mount,
      unmount
    } = this;

    const $context = __setupContext__.call(this, data, store);
    const views = VIEWS.map(view => view.call($context));

    return {
      method,
      name,
      views,
      mount: callback(mount).bind($context),
      unmount: callback(unmount).bind($context),
      $context
    };
  }
}

export default [
  // QR,
  CAPITEC,
  NQR,
  CARD,
  PAGA,
  USSD,
  MPESA,
  // BARTER,
  ENAIRA,
  PAYPAL,
  // WECHAT,
  ACCOUNT,
  FAWRYPAY,
  APPLE_PAY,
  GOOGLE_PAY,
  OPAY,
  // PAYATTITUDE,
  FLASH_VOUCHER,
  BANK_TRANSFER,
  CRYPTOCURRENCY,
  // INTERNET_BANKING,
  MOBILE_MONEY_GHANA,
  MOBILE_MONEY_FRANCO,
  MOBILE_MONEY_MALAWI,
  MOBILE_MONEY_RWANDA,
  MOBILE_MONEY_UGANDA,
  MOBILE_MONEY_ZAMBIA,
  MOBILE_MONEY_TANZANIA
].map(method => __initialize__.bind(method));
